import { render, staticRenderFns } from "./ImageIcon.vue?vue&type=template&id=3add9eba&"
import script from "./ImageIcon.vue?vue&type=script&lang=ts&"
export * from "./ImageIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports